import { render, staticRenderFns } from "./authorise.vue?vue&type=template&id=287d8366&scoped=true"
import script from "./authorise.vue?vue&type=script&lang=js"
export * from "./authorise.vue?vue&type=script&lang=js"
import style0 from "./authorise.vue?vue&type=style&index=0&id=287d8366&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d8366",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287d8366')) {
      api.createRecord('287d8366', component.options)
    } else {
      api.reload('287d8366', component.options)
    }
    module.hot.accept("./authorise.vue?vue&type=template&id=287d8366&scoped=true", function () {
      api.rerender('287d8366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sso/authorise.vue"
export default component.exports